export default {
    title: 'Cola de Atención',
    open_services: 'Servicios Abiertos',
    realized_services: 'Servicios Finalizados',
    position: 'º en la cola',
    realize: {
        success: 'Servicio completado con éxito.',
        error: 'Ocurrió un error al intentar guardar la finalización del servicio.'
    },
    filter: {
        title: 'Filtro',
        company: 'Empresa',
        unit_care: 'Unidad de Atención',
        sector: 'Sector',
        filter_button: 'Filtrar',
        clear_button: 'Limpiar Filtros'
    },
    caption: {
        title: 'Leyenda',
        service: 'Leyenda de Servicio',
        service_queue: 'Cola de Atención',
        service_waiting: 'Esperando Atención',
        realized_service: 'Servicio Finalizado',
        report_not_send: 'El resultado aún no ha sido enviado',
        report_sended: 'El resultado ha sido enviado',
    }
}
